import { Grid, Typography } from "@mui/material";
import ArrowIcon from "app/frontend/assets/icons/icn-carat.svg?react";
import { useIsMobilePhone } from "app/frontend/hooks/useIsMobilePhone";
import { IHeaderButtonContentProps } from "./types";

const HeaderButtonContent: React.FC<IHeaderButtonContentProps> = ({
  title,
  icon,
  isBlue,
  hideArrow,
}) => {
  const isMobilePhone = useIsMobilePhone();

  return (
    <Grid
      container
      sx={{
        width: "100%",
        justifyContent: { xs: undefined, md: "center" },
        alignItems: { xs: undefined, md: "center" },
      }}
    >
      <Grid
        size={hideArrow ? 12 : 10}
        sx={{
          display: "flex",
          flexDirection: "row",
          width: { xs: undefined, md: "100%" },
          alignItems: { xs: undefined, md: "center" },
        }}
      >
        {icon ? icon : null}
        <Typography
          variant={isMobilePhone ? "h3" : "body2"}
          component={"span"}
          sx={{
            fontWeight: "bold",
            textTransform: "none",
            fontSize: "12px",
            lineHeight: "18px",

            display: {
              xs: undefined,
              sm: isBlue ? "none" : undefined,
              md: "block",
            },

            fontFamily: "Lexend",
          }}
        >
          {title}
        </Typography>
      </Grid>
      {!hideArrow && (
        <Grid
          size={2}
          sx={{
            alignItems: "center",
            textAlign: "end",
            display: { xs: undefined, sm: "none" },
          }}
        >
          <ArrowIcon width={"1em"} style={{ transform: "rotate(270deg)" }} />
        </Grid>
      )}
    </Grid>
  );
};

export default HeaderButtonContent;
